import { gql } from '../../../apollo/__generated__';

export const DELETE_MILESTONE = gql(`
  mutation DeleteMilestone($milestoneId: ID!) {
    deleteMilestone(milestoneId: $milestoneId) {
      id
    }
  }
`);
